import script from "./MainComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./MainComponent.vue?vue&type=script&setup=true&lang=ts"

import "./MainComponent.vue?vue&type=style&index=0&id=141f322b&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-141f322b"]])

export default __exports__